<template>
  <div class="pagenation">
    <el-pagination
      background
      :current-page="pageNum"
      :page-sizes="sizesArr"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      :page-size="pageSize"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>
<script>
export default {
  name: 'Pagination',
  props: {
    pageNum: {
      type: Number,
      required: false,
      default: 1
    },
    pageSize: {
      type: Number,
      required: false,
      default: 10
    },
    sizesArr: {
      type: Array,
      default: () => ([10, 20, 30, 40])
    },
    total: {
      type: Number,
      required: false,
      default: 0
    }
  },
  methods: {
    handleSizeChange(data) {
      this.$emit('handleSizeChange', data)
    },
    handleCurrentChange(data) {
      this.$emit('handleCurrentChange', data)
    }
  }
}
</script>
<style lang="scss" scoped>
.pagenation {
  text-align: right;
  padding-top: 10px;
}
</style>
